import { externalApiClient } from '@/shared/lib/apiClient';

export interface LegalRegionView {
  legalRegionId: string;
  code: string;
  district?: {
    code: string;
    name?: string;
  };
}

/**
 * 법정 지역 개별 조회 (district.code 포함)
 * GeoJSON Firestore doc ID로 district.code 사용
 */
export async function fetchLegalRegionById(legalRegionId: string): Promise<LegalRegionView | null> {
  try {
    const response = await externalApiClient.get<LegalRegionView>(
      `/api/v1/admin/legal-regions/${legalRegionId}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch {
    return null;
  }
}

/**
 * 법정 지역 벌크 조회 (병렬 요청)
 * 백엔드에 bulk API가 없어 Promise.all로 병렬 호출
 */
export async function fetchLegalRegionsByIds(
  legalRegionIds: string[]
): Promise<Map<string, LegalRegionView | null>> {
  const uniqueIds = Array.from(new Set(legalRegionIds.filter(Boolean)));
  if (uniqueIds.length === 0) return new Map();

  const results = await Promise.all(
    uniqueIds.map(async (id) => {
      const data = await fetchLegalRegionById(id);
      return [id, data] as const;
    })
  );
  return new Map(results);
}
